'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import { CatalogRequestParams, RangeFacet } from '@/src/lib/category/types.ts';
import { usePathname, useRouter } from 'next/navigation';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
import FilterChipBar from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/components/Filters/FilterChipBar.tsx';
import Dropdown from '@/src/app/components/Dropdown/Dropdown.tsx';
import { buildRangeFacetChips } from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/lib/business/category-page-filters.ts';
import { LayoutTemplateContext } from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/LayoutTemplateProvider.tsx';
import RangeSlider from '@/src/app/components/RangeSlider/RangeSlider.tsx';
export type RangeFilterProps = {
  facet: RangeFacet;
  showChips?: boolean;
  dict: Dictionary;
  className?: string;
  plain?: boolean;
};
export default function RangeFilter(t0) {
  const $ = _c(33);
  const {
    facet,
    showChips,
    dict,
    className,
    plain: t1
  } = t0;
  const plain = t1 === undefined ? false : t1;
  const pathname = usePathname();
  const router = useRouter();
  const {
    startTransition,
    isPending
  } = useContext(LayoutTemplateContext);
  const isActive = facet.min !== facet.activeMin || facet.max !== facet.activeMax;
  let t2;
  if ($[0] !== dict || $[1] !== facet || $[2] !== showChips) {
    t2 = showChips ? buildRangeFacetChips(facet, dict) : [];
    $[0] = dict;
    $[1] = facet;
    $[2] = showChips;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const chips = t2;
  let t3;
  if ($[4] !== facet.max || $[5] !== facet.min || $[6] !== facet.name || $[7] !== pathname || $[8] !== router || $[9] !== startTransition) {
    t3 = t4 => {
      const [min, max] = t4;
      startTransition(async () => {
        const currentSearchParams = new URLSearchParams(window.location.search);
        if (min === facet.min) {
          currentSearchParams.delete(`${facet.name}[min]`);
        } else {
          currentSearchParams.set(`${facet.name}[min]`, `${min}`);
        }
        if (max === facet.max) {
          currentSearchParams.delete(`${facet.name}[max]`);
        } else {
          currentSearchParams.set(`${facet.name}[max]`, `${max}`);
        }
        currentSearchParams.set(CatalogRequestParams.PAGE, "1");
        router.push(decodeURI(`${pathname}?${currentSearchParams.toString()}`));
      });
    };
    $[4] = facet.max;
    $[5] = facet.min;
    $[6] = facet.name;
    $[7] = pathname;
    $[8] = router;
    $[9] = startTransition;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onChange = t3;
  const step = Math.max(Math.floor((facet.max - facet.min) / 15), 1);
  const t4 = `filter-${facet.name}`;
  let t5;
  if ($[11] !== dict || $[12] !== facet.activeMax || $[13] !== facet.activeMin || $[14] !== facet.isDisabled || $[15] !== facet.localizedName || $[16] !== facet.max || $[17] !== facet.min || $[18] !== facet.name || $[19] !== isActive || $[20] !== isPending || $[21] !== onChange || $[22] !== plain || $[23] !== step) {
    t5 = plain ? <><label htmlFor="" className="label">{facet.localizedName}</label><div className="bg-white p-2 mt-2 border border-gray-300"><RangeSlider dict={dict} min={facet.min} max={facet.max} activeMin={facet.activeMin} activeMax={facet.activeMax} handleChange={onChange} disabled={isPending || facet.isDisabled} step={step} className="px-5 pb-5 pt-3" /></div></> : <Dropdown name={facet.name} placeholder={facet.localizedName} isActive={isActive} disabled={isPending}><RangeSlider dict={dict} min={facet.min} max={facet.max} activeMin={facet.activeMin} activeMax={facet.activeMax} handleChange={onChange} disabled={isPending || facet.isDisabled} step={step} className="px-5 pb-5 pt-3" /></Dropdown>;
    $[11] = dict;
    $[12] = facet.activeMax;
    $[13] = facet.activeMin;
    $[14] = facet.isDisabled;
    $[15] = facet.localizedName;
    $[16] = facet.max;
    $[17] = facet.min;
    $[18] = facet.name;
    $[19] = isActive;
    $[20] = isPending;
    $[21] = onChange;
    $[22] = plain;
    $[23] = step;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== chips || $[26] !== showChips) {
    t6 = chips.length && showChips ? <FilterChipBar chips={chips} className="mt-2" /> : null;
    $[25] = chips;
    $[26] = showChips;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] !== className || $[29] !== t4 || $[30] !== t5 || $[31] !== t6) {
    t7 = <div className={className} data-testid={t4}>{t5}{t6}</div>;
    $[28] = className;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  return t7;
}